module.exports = __webpack_public_path__ + "static/media/2DGACM13.31f0689e.jpg";